import type { SxProps, Theme } from '@mui/material/styles';

export const landingPageStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100%',
    backgroundColor: theme.palette.background.default,
  }),
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    // Keep sections in normal document flow — no forced artboard width
  },
  /**
   * Groups hero + overlapping search so the negative margin stays
   * inside this band and does NOT pull the carousel up into the hero.
   */
  heroBand: {
    position: 'relative',
    width: '100%',
    // Sit tight under the nav (Figma ~8px gap)
    paddingTop: { xs: 1, md: '8px' },
    // Leave room below for the search bar that hangs past the hero
    paddingBottom: { xs: 3, md: 6 },
  },
};
